{
    "locale": "da-DK",
    "cart": {
        "engraving-line-1": "Indgraveringslinje 1",
        "engraving-line-2": "Indgraveringslinje 2",
        "key-number": "nøgle-nummer",
        "item-number-short": "Varenr.",
        "whatever": "Alle",
        "subtotal": "Subtotal",
        "shipping": "Forsendelse",
        "shipping-costs": "Forsendelsesomkostninger",
        "less-30eur-order-value": "ordre på under xx DKK",
        "without-vat-short": "ekskl. moms.",
        "with-percent-vat-short": "inkl. moms",
        "total": "I alt",
        "dealer-conditions-info": "Bemærk venligst, at dine forhandler-betingelser kun vil blive vist på fakturaen",
        "checkout now": "Videre til kassen",
        "cart-is-empty": "Din indkøbskurv er tom.",
        "shopping-now": "Køb nu",
        "remove": "Fjern",
        "close-cart": "Luk indkøbskurven"
    },
    "overlay": {
        "close": "Luk ned"
    },
    "properties": {
        "free-shipping": "Gratis fragt ved køb over 30 Euro (i DE)",
        "quick-delivery": "Korte leveringstider",
        "secure-payment": "Sikker betaling",
        "uncomplicated-purchase": "Ubesværet køb",
        "purchase-on-account": "Køb på faktura"
    },
    "dealer-login": {
        "headline": "Forhandler login",
        "logged-in-info-html": "Du er logget ind med forhandlernummer <b>{nummer}</b>.",
        "logout": "Log af",
        "dealer-number": "forhandlernummer",
        "error": "Der opstod en fejl. Prøv igen senere. ",
        "invalid-login": "Ugyldigt login",
        "login": "Log på",
        "prompt": "Indtast dit forhandlernummer og postnummer for at gå til forhandlerbutikken",
        "problem-contact-html": "Hvis du har problemer, kan du kontakte:<br /><a href=\"mailto:service@renz24.de\">service@renz24.de</a>",
        "password": "password"
    },
    "footer": {
        "overview": "Oversigt",
        "shop-service": "Butiksservice",
        "contact": "Kontaktinformation",
        "social-media": "Sociale medier",
        "sustainability": "Bæredygtighed",
        "sustainability-text": "RENZ anvender udelukkende grøn strøm.",
        "we-ship-with": "Vi sender med"
    },
    "header": {
        "menu": "Menu",
        "service-area": "Serviceområde",
        "my-orders": "Min ordre",
        "login": "Log ind",
        "logout": "Log ud",
        "back": "Tilbage",
        "purchase-on-account": "Køb på faktura",
        "short-delivery-time": "Korte leveringstider",
        "secure-payment": "Sikker betaling"
    },
    "mobile-search": {
        "headline": "Søg efter butik",
        "placeholder": "Artikelnavn eller artikelnummer"
    },
    "site-nav": {
        "all-products": "Alle produkter"
    },
    "econfig-teaser": {
        "to-configurator": "Til konfigurator",
        "to-products": "Til produkter"
    },
    "options": {
        "headline": "Valg",
        "confirm-selection": "Bekræft valg"
    },
    "inquiry": {
        "error-alert": "Der er opstået en fejl. Anmodningen blev ikke behandlet. Prøv venligst igen senere.",
        "headline": "Send en anmodning",
        "success": "Tak for din forespørgsel!",
        "success-headline-offer-assistant": "Din anmodning er blevet videresendt",
        "success-offer-assistant": "Din anmodning er blevet videresendt til den forhandler, du har valgt til behandling.",
        "firstname": "Fornavn",
        "optional": "Valgfri",
        "lastname": "Efternavn",
        "company": "Firma",
        "street": "Gade/vej",
        "house-number": "Husnummer",
        "country": "Land",
        "default-country": "Danmark",
        "postcode": "Postnummer",
        "city": "By",
        "email": "e-mail",
        "phone": "Telefonnummer",
        "phone-tooltip": "Telefonnummeret videregives evt. til speditøren.",
        "commission": "Kommission",
        "construction-project": "Byggeprojekt",
        "special-request": "Særlig anmmodning",
        "special-request-placeholder": "Ved at indtaste en særlig anmodning kan dette tilbud ikke længere genereres automatisk. En forhandler vil derefter kontakte dig i løbet af de næste par dage.",
        "dealer-choice-intro": "Vælg venligst en forhandler nedenfor. Herefter modtager du et uforpligtende tilbud inden for de næste par minutter.",
        "dealer-choice-prompt": "Vælg en specialforhandler",
        "local-dealer": "Lokale forhandlere",
        "please-choose": "Vælg venligst",
        "within-radius-of": "Inden for",
        "no-dealer-within-radius": "Der blev ikke fundet nogen forhandlere i nærheden",
        "no-dealer-for-postcode": "Søgningen gav ikke noget resultat for det angivne postnummer",
        "or": "eller",
        "renz-online-partner": "Renz online partner",
        "privacy-terms-checkbox-html": "Ved at indsende denne formular accepterer du <a href=\"/service/datenschutz\" >RENZ privatlivspolitik </a >.<br /> Dine data vil blive videresendt til den forhandler, du har valgt ovenfor, så de kan give dig et individuelt tilbud.",
        "send": "Afsend",
        "dealer-preselected-intro": "Anmodningen går til følgende specialforhandlere:",
        "customer-type": {
            "end": "Slutkunde",
            "business": "Erhvervskunde",
            "desired-retail-partner-label": "Ønsket handelspartner",
            "desired-retail-partner-placeholder": "Indtast din ønskede handelspartner med lokation og kontaktperson."
        }
    },
    "product": {
        "load-more": "Indlæs mere",
        "item-number-short": "varenr.",
        "preview-not-matching-color": "Den aktuelle forhåndsvisning svarer ikke til den valgte farve!",
        "options": "Valgmuligheder",
        "no-option-selected": "Ingen valgmulighed valgt",
        "retail-price-excl-vat": "Producentens vejledende udsalgspris ekskl. moms",
        "retail-price-incl-vat": "Producentens vejledende udsalgspris inkl. moms",
        "choose-color": "Vælg farve",
        "choose-color-intro-html": "Hos Renz er der over 200 farver at vælge imellem, og du kan helt sikkert finde den ønskede nuance. De fleste farver er taget fra RAL-farveregisteret. Farvernes glansniveau er angivet i glansenheder (=GE). Bemærk: Bemærk venligst, at de viste farver ikke er bindende. For den nøjagtige farvetone henvises til RAL-farveregisteret 841-GL eller til en original Renz-DB farveprøve.",
        "search-color": "Søg efter farve",
        "colors-with-preview": "Farver med forhåndsvisning",
        "colors-without-preview": "Farver uden forhåndsvisning ",
        "back-to-overview": "Tilbage til oversigten",
        "delivery-time": "Leveringstid",
        "working-days": "Arbejdsdage",
        "weeks": "uger",
        "retail-price": "Producentens mindstepris",
        "excl-vat": "ekskl. moms.",
        "incl-vat": "inkl. moms",
        "plus-shipping": "plus forsendelsesomkostninger",
        "dealer-conditions-info": "Bemærk venligst, at dine kendte betingelser kun vil blive vist på fakturaen..",
        "dealer-fixed-price-info": "",
        "any-key-number": "Et vilkårligt nøglenummer",
        "key-number": "nøgletal",
        "key-number-in-range-from": "Venligst indtast det nøglenummer, du har brug for, uden bogstaver: i området fra",
        "key-number-in-range-to": "til",
        "engraving-line-1": "Indgraveringslinje 1",
        "count-characters-left-html": "Der er stadig <span class=\"num\">{count}</span> tegn til rådighed",
        "engraving-line-2": "Indgraveringslinje 2",
        "make-inquiry": "Send en anmodning",
        "add-to-cart": "Tilføj til kurv",
        "description": "Beskrivelse",
        "downloads": "Downloads",
        "quantity": "Mængde"
    },
    "product-filter": {
        "material": "Materialer",
        "all-materials": "Alle materialer",
        "plastic": "Kunststof",
        "aluminium": "Aluminium",
        "stainless-steel": "Rustfrit stål",
        "price": "Pris",
        "punch-width": "Stansningsbredde",
        "punch-height": "Stansningshøjde",
        "outer-width": "Udvendig bredde",
        "outer-height": "Udvendig højde",
        "construction-year": "Produktionsår",
        "reset-all": "Nulstil alt"
    },
    "checkout": {
        "back": "Tilbage",
        "next": "Næste",
        "info-and-shipping": "Informationen & levering",
        "payment": "Betaling",
        "summary": "Oversigt",
        "order": "Bestilling",
        "thank-you-for-order": "Mange tak for din bestilling.",
        "order-comfirmation-html": "Tak fordi du valgte Renz Shop. Du vil om kort tid modtage en ordrebekræftelse fra os til den e-mailadresse, du har angivet.",
        "error-alert": "Der er opstået en fejl. Ordren blev ikke behandlet. Prøv venligst igen senere.",
        "cart": "Kurv",
        "delivery-and-billing-address": "Levering - og faktureringsadresse",
        "dealer-number": "Forhandlernummer",
        "dealer-address-info-html": "De adresseoplysninger, vi har i vores database, vil blive anvendt. Hvis disse oplysninger ændres, bedes du kontakte os.",
        "further-data": "Mere data",
        "dealer-email-prompt": "Du kan indtaste din e-mailadresse her, hvis du ønsker at modtage en ordrebekræftelse pr. e-mail",
        "email": "e-mail",
        "dealer-commission-prompt": "Følgende kommissionsfelt er gemt i din ordrebekræftelse",
        "commission": "Kommission",
        "invoice": "Faktura",
        "store-my-data": "Gem min data på denne computer",
        "order-now": "Bestil nu",
        "contact-data": "Kontaktdata",
        "phone": "Telefonnummer",
        "shipping-address": "Leveringsadresse",
        "firstname": "Fornavn",
        "lastname": "Efternavn",
        "street": "Gade",
        "house-number": "Husnummer",
        "postcode": "Postnummer",
        "city": "By",
        "country": "Land",
        "billing-address": "Faktureringsadresse",
        "back-to-payment": "Tilbage til betaling",
        "paypal-error-alert": "PAYPAL FEJL: Prøv venligst igen senere.",
        "pay-via-invoice": "Betal via faktura.",
        "paypal-language-code": "dk_DK",
        "payment-type": "Betalingsmetode",
        "invoice-possible-notice-html": "Køb på regning er kun muligt op til et fakturabeløb på xx DKK.",
        "back-to-shipping": "Tilbage til forsendelse ",
        "contact-info": "Kontaktinformation",
        "optional": "Valgfri",
        "delivery-country-notice-html": "Bemærk venligst, at vi i øjeblikket <b>kun leverer i Danmark</b>.",
        "back-to-shop": "Tilbage til butikken",
        "proceed-to-payment": "Videre til betaling",
        "checkout": "Kasse",
        "right-of-withdrawal-checkbox-html": "Jeg har noteret mig <a href=\"/service/cancellation\" onclick=\"return openOverlay(this.href)\" >afbestillingsreglerne</a >.",
        "privacy-terms-checkbox-html": "Jeg har læst og forstået <a href=\"/service/privacy\" onclick=\"return openOverlay(this.href)\">fortrolighedspolitik</a >.",
        "general-terms-checkbox-html": "Jeg har læst og forstået <a href=\"/service/agb\" onclick=\"return openOverlay(this.href)\" >Vilkår og betingelser</a >.",
        "klarna": "Klarna",
        "paypal": "Paypal",
        "address-supplement": "adressetillæg",
        "company": "Selskab",
        "same-as-shipping-address": "Samme som leveringsadressen",
        "different-billing-address": "En anden faktureringsadresse"
    },
    "meta": {
        "description": "Renz Shop for reservedele, graveringsservice og brevkasser."
    },
    "contact-form": {
        "success": "Vi har modtaget din besked. Vi behandler din anmodning så hurtigt som muligt.",
        "error": "Der er opstået en fejl. Prøv igen senere.",
        "firstname": "Fornavn",
        "optional": "optional",
        "lastname": "Efternavn",
        "email": "e-mail",
        "street": "Gade",
        "house-number": "Husnummer",
        "postcode": "Postnummer",
        "city": "By",
        "subject": "Emne",
        "message": "Besked",
        "file-upload": "Upload af fil",
        "send": "Send",
        "privacy-terms-checkbox-html": "Jeg har noteret mig <a href=\"/service/privacy\" onclick=\"return openOverlay(this.href)\" >Fortrolighedspolitik</a >."
    },
    "category": {
        "products": "Produkt",
        "sorting": "Sortering",
        "by-name": "Navn",
        "by-price-asc": "Pris ↥",
        "by-price-desc": "Pris ↧"
    },
    "service": {
        "service-area": "Serviceområde",
        "service": "Service"
    },
    "search": {
        "search-for": "Søg efter {search}",
        "search-for-html": "Produktsøgning <small>efter {search}</small",
        "count-hits": "{Tæller} Hit",
        "sorting": "Sortering",
        "by-name": "Sorteret med navn",
        "by-price-asc": "Stigende priser",
        "by-price-desc": "Faldende priser"
    },
    "home": {
        "search-placeholder": "Artikelname eller artikelnummer",
        "search": "Søg"
    },
    "my-orders": {
        "order-details": "Ordredetaljer",
        "order-intro-html": "Tak for din bestilling. Du kan finde oplysningerne nedenfor.",
        "back-to-orders": "Tilbage til bestilling.",
        "order-from-date": "Ordre fra {dato}.",
        "order-number-short": "ordrenr.",
        "payment-info": "Betalingsinformation.",
        "invoice": "Faktura.",
        "contact": "Kontakt.",
        "email": "e-mail.",
        "phone": "Telefonnummer.",
        "firstname": "Fornavn.",
        "lastname": "Efternavn.",
        "street-and-house-number": "Vej/gadenavn og husnummer.",
        "postcode": "Postnummer.",
        "city": "By.",
        "country": "Land.",
        "ordered-items": "Bestilte varer.",
        "item-number-short": "varenr.",
        "engraving-line-1": "Indgraveringslinje 1.",
        "engraving-line-2": "Indgraveringslinje 2.",
        "key-number": "Nøglenummer.",
        "whatever": "Alle.",
        "pieces": "Stk.",
        "shipping-costs": "Forsendelsesomkostninger.",
        "total-costs": "Pris i alt.",
        "vat-included": "Moms inkluderet.",
        "order-not-found": "Din ordre blev ikke fundet.",
        "my-orders": "Mine bestillinger.",
        "intro-html": "Her finder du en oversigt over alle dine ordrer.",
        "click-link-prompt": "Klik her for at anmode om et nyt link.",
        "access-denied": "Adgang nægtet.",
        "link-is-invalid": "Linket er ugyldigt.",
        "view-order": "Vis ordre.",
        "no-order-for-email-html": "Der er endnu ikke blevet gemt nogen ordrer i vores system for din e-mailadresse.",
        "load-more": "Indlæs mere.",
        "error": "Der opstod en fejl. Prøv igen senere. ",
        "link-request-intro-html": "Hvis du allerede har afgivet en ordre, kan du se din ordrehistorik her med den anvendte e-mailadresse.",
        "link-request-success": "Linket er blevet sendt til dig via e-mail. Tjek venligst din e-mail-indbakke og om nødvendigt din spam-mappe.",
        "send-link": "Send ordrelink."
    },
    "not-found": {
        "site-not-found": "Siden blev ikke fundet."
    },
    "product-config": {
        "configurator": "Konfigurator.",
        "reset-all": "Ryd alle filtre.",
        "back": "Tilbage.",
        "next": "Videre.",
        "select-not-included": "Dit valg er ikke inkluderet.",
        "item-number-short": "varenr.",
        "more-details": "Flere detaljer.",
        "retail-price": "Butikspris.",
        "excl-vat": "ekskl. moms",
        "incl-vat": "inkl. moms",
        "make-inquiry": "Lav en forespørgsel"
    },
    "klarna": {
        "error": "Der opstod en fejl! Prøv igen.",
        "order_now": "Bestil nu og betal med Klarna",
        "proceed": "fortsæt med Klarna"
    },
    "paypal": {
        "order_now": "Betal nu og bestil med"
    },
    "offer-assistant": {
        "title": "Konfigurator",
        "ok": "Okay",
        "close": "Afslut konfigurator",
        "welcome-title": "Velkommen til konfiguratoren",
        "welcome-text": "Her giver vi dig mulighed for at konfigurere dit postkassesystem i detaljer.<br/>For at gøre dette skal du gennemgå trinene efter hinanden og vælge de ønskede egenskaber.<br/>Efter færdiggørelsen vil du om kort tid modtage et detaljeret tilbud inklusiv tilbudstekst, teknisk tegning og fotorealistisk visning."
    }
}
